<template>
    <div class="mt-3 mb-3">
        <b-card>
            <h3 class="strong">My Calculations</h3>
            <b-row class="mt-4 mb-4">
                <b-col sm="3">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Filter..." autocomplete="off"></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col sm="4" offset="5" style="text-align: right">
                    <b-button variant="dark" @click="didTapCreate">
                        <font-awesome-icon icon="plus-circle" />&ensp;Add New Calculation
                    </b-button>
                </b-col>
            </b-row>
            <b-table
                striped hover outlined fixed
                show-empty
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :busy="busy"
                @filtered="onFiltered"
            >
                <template slot="type" slot-scope="row">
                    <b-badge v-if="row.item.type == 'Vertical'" variant="info">Vertical</b-badge>
                    <b-badge v-else variant="success">Directional</b-badge>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button size="sm" variant="primary" @click="goToDetail(row.item)" class="mr-1">
                        <font-awesome-icon icon="search"/>&ensp;Detail
                    </b-button>
                </template>
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>&emsp;
                        <strong>Loading your calculations, please wait...</strong>
                    </div>
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col md="4">
                <b-button variant="dark" disabled>
                    {{ totalRows }} calculation(s)
                </b-button>
                </b-col>
                <b-col md="8">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "dashboard",
    data() {
        return {

            wellName: "",
            filter: "",
            fields: [
                { key: "name", label: "Name",  sortable: true},
                { key: "field", label: "Field" },
                { key: "type", label: "Type" },
                { key: "instrument", label: "Instrument" },
                { key: "method", label: "Method" },
                { key: "date", label: "Date",sortable: true },
                { key: "actions", label: "Actions" }
            ],
            items: [],
            busy: true,

            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: ""

        }
    },
    methods: {

        onFiltered(items) {
            this.totalRows = items.length
            this.currentPage = 1
        },

        didTapCreate() {
            this.$router.push("/create")
        },

        goToDetail(item) {
            this.$core.id = item.id
            this.$router.push("/input")
        }

    },
    created: function() {

        // Fetch calculations
        this.$axios.get('/calc').then(response => {

            let res = response.data
            if(res.message == "OK") {
                this.items = res.data.calculations
                this.totalRows = this.items.length
            }
            else {
                this.$helper.toastError(this, 'Failed to retrieve calculations.')
            }

        }).catch(error => {
            this.$helper.toastError(this, 'Failed to retrieve calculations.')
        })
        .finally(() => {
            this.busy = false
        })

    }
}
</script>

<style scoped>
    .right {
        text-align: end;
    }

    /* .alignMiddle >>> td {
        vertical-align: middle !important;
    } */
</style>